// extracted by mini-css-extract-plugin
export var footer = "_l2-5";
export var fulfillmentInput = "_l2-0";
export var shipDateInput = "_l2-1";
export var shipmentModal = "_l2-2";
export var shipmentModalContent = "_l2-3";
export var tableContainer = "_l2-4";